export default __webpack_public_path__ + "static/media/GRORatingsLogo.d8836105.svg";